import { usePage } from "@inertiajs/react"
import type { PageProps } from "@/types/inertia"

/**
 * Renders the shared `flash` prop. Mutations redirect with a notice, and until
 * this existed nothing in the app displayed one — "Saved." went nowhere.
 */
export function FlashNotice() {
  const { props } = usePage<PageProps>()
  const notice = props.flash?.notice
  const alert = props.flash?.alert

  if (!notice && !alert) return null

  return (
    <div
      role="status"
      className={`callout mb-6 py-3 ${alert ? "callout-danger" : "callout-accent"}`}
    >
      <p className={`text-sm ${alert ? "text-danger-display" : "text-accent-display"}`}>
        {alert ?? notice}
      </p>
    </div>
  )
}
